// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-provider-selector {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  z-index: 9999;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 12px;
}
.payment-provider-selector__label {
  margin-bottom: 8px;
  font-weight: 500;
}
.payment-provider-selector__controls {
  display: flex;
  gap: 4px;
}
.payment-provider-selector__button {
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
}
.payment-provider-selector__button:hover {
  background: #f5f5f5;
}
.payment-provider-selector__button.active {
  background: #007bff;
  color: white;
  border-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/PaymentProviderSelector/PaymentProviderSelector.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,qCAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,wCAAA;EACA,eAAA;AACF;AACE;EACE,kBAAA;EACA,gBAAA;AACJ;AAEE;EACE,aAAA;EACA,QAAA;AAAJ;AAGE;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AADJ;AAGI;EACE,mBAAA;AADN;AAII;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AAFN","sourcesContent":[".payment-provider-selector {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 10px;\n  z-index: 9999;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  font-size: 12px;\n\n  &__label {\n    margin-bottom: 8px;\n    font-weight: 500;\n  }\n\n  &__controls {\n    display: flex;\n    gap: 4px;\n  }\n\n  &__button {\n    padding: 4px 8px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background: white;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: #f5f5f5;\n    }\n\n    &.active {\n      background: #007bff;\n      color: white;\n      border-color: #0056b3;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
